"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
var utils_1 = require("../../utils");
exports.default = (0, utils_1.makeGenericNetworkReducer)(actions_1.FETCH_LAYERS, actions_1.ADD_LAYER, actions_1.UPDATE_LAYER, actions_1.DELETE_LAYER);
